import { Outlet } from "react-router-dom";
import Layout from "./components/ui/layout/mainLayout";
import Host from "./pages/Host/Host";
import Server from "./pages/Sever/Server";
import AboutUs from "./pages/AboutUs/AboutUs";
import Contact from "./pages/Contact/Contact";
import OurCustomers from "./pages/ourCustomers/ourCustomers";
import Domain from "./components/ui/Navbar/Domain/Domain";
import Moodle from "./pages/Moodle/Moodle";
import BigBlueButton from "./pages/BigBlueButton/BigBlueButton";
import Licenses from "./pages/Licenses/Licenses";
import SSL from "./pages/SSL/SSL";
import BackUp from "./pages/BackUp/BackUp";
import ScientificArticles from "./pages/scientificArticles/scientificArticles";
import LearningArticles from "./pages/LearningArticle/LearningArticle";
import Developers from "./pages/Developers/Developers";
import MainPage from "./pages/MainPage/MainPage";
const Routes = [
  {
    path: "/",
    element: (
      <Layout>
        <Outlet />
      </Layout>
    ),
    children: [
      {
        path: "/aboutus",
        element: <AboutUs />,
      },
      {
        path: "/product/:name",
        element: <Host />, // Handles product details
      },
      {
        path: "/server/:name", // Route for Server component
        element: <Server />,
      },
      {
        path: "/product/Licenses",
        element: <Licenses />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/our-customers",
        element: <OurCustomers />,
      },
      {
        path: "/Domain",
        element: <Domain />,
      },
      {
        path: "/Moodle",
        element: <Moodle />,
      },
      {
        path: "/BigBlueButton",
        element: <BigBlueButton />,
      },
      {
        path: "/SSL",
        element: <SSL />,
      },
      {
        path: "/BackUp",
        element: <BackUp />,
      },
      {
        path: "product/scientific-articles",
        element: <ScientificArticles />,
      },
      {
        path: "product/learning-articles",
        element: <LearningArticles />,
      },
      {
        path: "/Developers",
        element: <Developers />,
      },
      {
        path: "/Developers",
        element: <Developers />,
      },
      {
        path: "/",
        element: <MainPage />,
      },
    ],
  },
];

export default Routes;
